import React from 'react';
import ClickableElement from 'src/components/ClickableElement';
import styles from './Modal.scss';
import { ClickAnalyticsOptions } from 'src/redux/modules/analytics';

interface Props {
  colorTheme?: 'light' | 'dark';
  contentLabel?: string;
  isOpen?: boolean;
  onClose?: () => void;
  shouldCloseOnOverlayClick?: boolean;
  closeAnalyticsTracking?: ClickAnalyticsOptions;
  noBackground?: boolean;
  scrollToTop?: boolean;
  scrollToTopOnClose?: boolean;
  maintainPosition?: boolean;
  large?: boolean;
}

class ModalInner extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  handleKeyUp = (e: KeyboardEvent) => {
    if (e.keyCode === 27) {
      this.handleModalClose();
    }
  };

  handleModalClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleClickOutsideModal = () => {
    if (this.props.isOpen) {
      this.handleModalClose();
    }
  };

  preventBodyToScroll = (e: TouchEvent) => {
    e.stopPropagation();
  };

  componentDidMount() {
    const { scrollToTop } = this.props;

    document.body.classList.add(
      this.props.maintainPosition ? 'no-scroll' : 'body-fixed'
    );

    if (scrollToTop) {
      window.scrollTo(0, 0);
      return;
    }

    document.addEventListener('keyup', this.handleKeyUp);
    document.body.addEventListener('touchmove', this.preventBodyToScroll);
  }

  componentWillUnmount() {
    const { scrollToTopOnClose } = this.props;
    document.body.classList.remove(
      this.props.maintainPosition ? 'no-scroll' : 'body-fixed'
    );

    if (scrollToTopOnClose) {
      window.scrollTo(0, 0);
    }

    document.removeEventListener('keyup', this.handleKeyUp);
    document.body.removeEventListener('touchmove', this.preventBodyToScroll);
  }

  render() {
    const {
      closeAnalyticsTracking,
      colorTheme,
      contentLabel,
      onClose,
      noBackground,
      large,
    } = this.props;

    const hasClose = !!onClose;

    return (
      <div
        className={styles.overlay}
        onClick={
          this.props.shouldCloseOnOverlayClick
            ? this.handleModalClose
            : () => {}
        }
      >
        <div
          className={`
            ${noBackground ? styles.modal : styles['modal-background']}
            ${large ? styles['modal--large'] : ''}
          `}
          aria-label={contentLabel}
          onClick={e => e.stopPropagation()}
        >
          {hasClose && (
            <ClickableElement
              onClick={this.handleModalClose}
              className={`${
                styles[`${colorTheme}-close-button`]
              } qa-close-button`}
              analyticsOptions={closeAnalyticsTracking}
              inline
            >
              Close
            </ClickableElement>
          )}
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default ModalInner;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalInner.tsx